export default "__VITE_ASSET__c93c0454__"